var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.buttonClass},_vm.$listeners),[(_vm.icon)?_c('span',{class:_vm.iconClass}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"p-button-text p-c"},[_vm._v(_vm._s(_vm.label||'p-btn'))])])}
var staticRenderFns = []

export { render, staticRenderFns }